import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { EventEmitter } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Subject } from "rxjs";
import { Address } from "../../../../core/models/shared/address";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { GetAllVendorsDto } from "../../../../core/models/vendor/getAllVendors";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { computeMinDate } from "../../../../core/utilities/mindate-function";

@UntilDestroy()
@Component({
  selector: "jni-add-line",
  templateUrl: "./add-line.component.html",
  styleUrls: ["./add-line.component.scss"],
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    DatePickerModule,
    ReactiveFormsModule,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
  ],
})
export class AddLineComponent implements OnInit, OnChanges {
  constructor(
    private _samplepoListingService: SamplepoListingService,
    public datepipe: DatePipe
  ) {}
  @Input() parent!: FormGroup;
  @Input() shipDateOne = new Date().toISOString();
  @Input() inHandDateOne = new Date().toISOString();
  @Input() firmOneCheckBox = false;
  @Input() currencyConversion?: ExchangeRatesDto;
  @Input() isSummary = false;
  @Input() addLineType = "create";
  @Input() lineNumber = 0;
  @Input() currencyConversionStatus = false;
  @Input() formErrors!: Record<string, string>;
  @Input() shipDateFormControl!: string;
  @Input() inHandDateFormControl!: string;
  @Input() createNewLineTrigger!: Subject<boolean>;

  @Output() validationEvent = new EventEmitter();
  @Output() showPositionDialogDescriptionEvent = new EventEmitter<
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topleft"
    | "topright"
    | "bottomleft"
    | "bottomright"
  >();
  @Output() showPositionDialogFactoryEvent = new EventEmitter();

  showSmallLoader = false;
  shipDate = new Date();
  inHandDate = new Date();

  shipDateCurrentdate = computeMinDate();
  @Input() inHandDateCurrentdate = computeMinDate();

  samplePoList: GetAllVendorsDto[] = [];
  clientLists: ClientSearchList[] = [];
  addressBookList: Address[] = [];
  shiftToAddressField = "";
  releasedProductsList: ReleasedProduct[] = [];
  shippingProductsList: ShippingMethod[] = [];
  selectedAccountNumber = "";
  isAddressValidationButton = true;
  netValueWithIcon = 0;
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = 0;
  netTotalPriceConverted = "";

  @ViewChild("vendorSKU")
  vendorSKUElement!: ElementRef<HTMLElement>;

  ngOnInit(): void {
    this.getAllReleaseProduct();
    if (this.createNewLineTrigger) {
      this.createNewLineTrigger.subscribe((v: boolean) => {
        if (v === true) {
          this.vendorSKUElement.nativeElement.focus();
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["shipDateOne"]) {
      if (changes["shipDateOne"].currentValue) {
        this.parent.patchValue({
          lines: {
            requestedShippingDateD365: changes["shipDateOne"].currentValue,
          },
        });
      }
    }
    if (changes["inHandDateOne"]) {
      if (changes["inHandDateOne"].currentValue) {
        this.parent.patchValue({
          lines: {
            requestedDeliveryDateD365: changes["inHandDateOne"].currentValue,
          },
        });
      }
    }
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            x =>
              x.itemNumberD365 != "Misc" &&
              x.productTypeD365 === "Service" &&
              x.poStopped === "No"
          );
        },
      });
  }

  // onInHandDateSelection(event: any) {
  //   this.inHandDate = event.target.value;
  //   this.inHandDateOne = event.target.value;
  // }

  onShipDateOneSelection(event: Date) {
    // this.shipDateOne = event;
    const shipDate = new Date(event);
    this.shipDateOne = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    if (this.shipDateOne) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDateOne, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.parent.patchValue({
      lines: {
        requestedShippingDateD365: this.shipDateOne,
      },
    });
  }

  onInHandDateOneSelection(event: Date) {
    //this.inHandDateOne = event;
    const inHandDate = new Date(event);
    this.inHandDateOne =
      this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.parent.patchValue({
      lines: {
        requestedDeliveryDateD365: this.inHandDateOne,
      },
    });
  }

  onQuantityChange(event: Event) {
    const eventTarget = event?.target as HTMLInputElement;
    this.showSmallLoader = true;
    let quantity = eventTarget.value.toString().replace(/[^-0-9]/g, "");
    quantity = quantity.includes("-")
      ? quantity.substring(0, 10)
      : quantity.substring(0, 9);
    if (quantity) {
      this.patchValueInQuantityAfterRemoveAlpabet(quantity);
      let netPrice = this.parent.get(["lines", "purchasePriceD365"])
        ?.value as string;
      if (netPrice) {
        netPrice = netPrice.toString().replace(/[^a-zA-Z0-9.]/g, "");
        const convertedNetPrice = this.netConvertToUsd.replace(
          /[^a-zA-Z0-9.]/g,
          ""
        );
        this.patchValueInTotalNet(netPrice, convertedNetPrice);
      }
      this.showSmallLoader = false;
    } else {
      this.showSmallLoader = false;
      this.patchValueInQuantity();
      this.clearlinePriceValue();
    }
  }

  patchValueInQuantity() {
    this.parent.patchValue({
      lines: {
        orderedPurchaseQuantityD365: 1,
      },
    });
  }

  patchValueInQuantityAfterRemoveAlpabet(quantity: string) {
    this.parent.patchValue({
      lines: {
        orderedPurchaseQuantityD365: parseInt(quantity),
      },
    });
  }

  clearlinePriceValue() {
    this.parent.patchValue({
      lines: {
        purchasePriceD365: 0,
        lineAmountD365: 0,
        netConversion: 0,
        netConversionTotal: 0,
      },
    });
    this.netTotalPrice = 0;
    this.netValueWithIcon = 0;
    this.netConvertToUsd = "";
    this.netTotalPriceConverted = "";
  }

  patchValueInTotalNet(net: string, convertedNet: string) {
    const quantity = this.parent.get([
      "lines",
      "orderedPurchaseQuantityD365",
    ])?.value;
    if (quantity) {
      const netprice = parseFloat(net) * parseInt(quantity);
      this.netTotalPrice = netprice;
      const netPriceCon =
        parseFloat(convertedNet == "" ? "0" : convertedNet) *
        parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      this.patchValueInNetTotalNet(
        this.netTotalPrice,
        this.netTotalPriceConverted
      );
    }
  }

  patchValueInNetTotalNet(
    netTotalPrice: number,
    netTotalPriceConverted: string
  ) {
    this.parent.patchValue({
      lines: {
        lineAmountD365: netTotalPrice,
        netConversionTotal: parseFloat(netTotalPriceConverted),
      },
    });
  }

  patchValueInNet(netConvertToUsd: string) {
    this.parent.patchValue({
      lines: {
        netConversion: parseFloat(netConvertToUsd),
      },
    });
  }

  onNetConversion(event: Event) {
    const targetValue = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    let netRate = targetValue.value.replace(/[^.0-9.0-9]/g, "");
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(netRate) ? "valid" : "invalid";
    if (revenue === "valid" && netRate !== "") {
      netRate = netRate.substring(0, 9);
      this.patchValueInNetPrice(netRate);
      if (netRate) {
        this.netValueWithIcon = Number(netRate);
        const currency = this.parent.get(["header", "currencyCodeD365"])?.value;
        this.isoCurrencyCode = currency;
        if (this.currencyConversion) {
          if (this.currencyConversion.Rate != 0) {
            this.netReteAfterConversion =
              parseFloat(netRate) * this.currencyConversion?.Rate;
            if (this.netReteAfterConversion.toString() != "") {
              this.netConvertToUsd = this.netReteAfterConversion.toString();
              this.patchValueInNet(this.netConvertToUsd);
            }
          }
        } else {
          this.netReteAfterConversion = 0;
        }
        this.patchValueInTotalNet(
          netRate,
          this.netReteAfterConversion.toString()
        );
      }
    } else {
      this.clearlinePriceValue();
    }
    this.showSmallLoader = false;
  }

  patchEmptyValueInNetPrice() {
    this.parent.patchValue({
      lines: {
        purchasePriceD365: "",
      },
    });
  }

  patchValueInNetPrice(netPrice: string) {
    this.parent.patchValue({
      lines: {
        purchasePriceD365: parseFloat(netPrice),
      },
    });
  }

  getLineNumber(): number {
    if (this.addLineType == "create") {
      return (this.parent.get("linesArray") as FormArray).length + 1;
    }
    return this.parent.get(["lines", "lineNumberD365"])?.value;
  }

  // getFormValue(key: string) {
  //   this.parent.get(["lines", key])?.value as ;
  // }

  logValidationErrors() {
    this.validationEvent.emit();
  }

  showPositionDialogDescription(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.showPositionDialogDescriptionEvent.emit(position);
  }

  showPositionDialogFactory(position: string) {
    this.showPositionDialogFactoryEvent.emit(position);
  }
}
